module.exports = __webpack_public_path__ + "media/images/solicitud/proveedor-b5b4a01f6fcbeedc2ccdc5b800228f47.svg";